import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MotionConfig } from "framer-motion";
import App from "./App";
import { ThemeProvider } from "./lib/theme";
// Inter self-hosted via @fontsource (ferramenta interna: sem depender de
// Google Fonts/CDN externo so para renderizar texto). Pesos usados: 400
// (corpo), 500/600 (titulos de linha/card), 700 (h1 e numeros de stat card).
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./styles/global.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Elemento #root nao encontrado em index.html.');
}

createRoot(rootElement).render(
  <StrictMode>
    {/* reducedMotion="user": todo componente Framer Motion da app respeita
        `prefers-reduced-motion` automaticamente (transforms/escala viram
        instantaneos), sem precisar checar isso manualmente em cada tela. */}
    <MotionConfig reducedMotion="user">
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </MotionConfig>
  </StrictMode>,
);
